import { HairColorOptionsType } from './types';

export const HAIR_COLOR_OPTIONS: HairColorOptionsType = [
  {
    id: 'blonde',
    title: 'Blonde',
  },
  {
    id: 'brunette',
    title: 'Brunette',
  },
  {
    id: 'black',
    title: 'Black',
  },
  {
    id: 'red',
    title: 'Redhead',
  },
];
